import { Button, Col, Form, Modal, PageHeader } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BillingClient from "redux/models/billingClients";
import { selectConfigration } from "redux/slices/configrationSlice";
import { selectUser, selectUserId } from "redux/slices/userSlice";
import K from "utilities/constants";
import LayoutCss from "layout/layout.module.scss";
import { DataTableLayout } from "../../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../../hooks/usePageFilters";
import { getColumns } from "./columns";
import AddNewClientBillingJob from "./addNewClientBillingJob";

export default function BillingClients() {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);
  const userSlice = useSelector(selectUser);
  const billingClientData = useSelector(selectConfigration).billingClients;

  const [search, setSearch] = usePageFilter("billing_clients_search");

  const [form] = Form.useForm();
  const [pageState, setPageState] = useState({
    editData: null,
    isLoading: false,
    isModalVisible: false,
  });

  const showModal = () => {
    setPageState((prev) => ({ ...prev, isModalVisible: true }));
  };

  const editHandler = (record) => {
    setPageState((prev) => {
      return {
        ...prev,
        isModalVisible: true,
        editData: record,
      };
    });
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setPageState((prev) => ({
      ...prev,
      editData: null,
      isModalVisible: false,
    }));
  };

  const afterModalClose = () => {
    form.resetFields();
  };

  const getAllBillings = async () => {
    try {
      await dispatch(BillingClient.getAll());
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getAllBillings();
  }, []);

  return (
    <>
      <PageHeader
        ghost={false}
        title="Client Level Configuration"
        className={LayoutCss.appPageHeader}
      />

      <DataTableLayout
        searchDefaultValue={search}
        onSearchChange={setSearch}
        actions={[
          {
            permissions: [K.Permissions.CreateClientBilling],
            renderer: () => (
              <Col>
                <Button type="primary" onClick={showModal}>
                  Add New
                </Button>
              </Col>
            ),
          },
        ]}
      >
        <ClientSideDataGrid
          userId={userId}
          configKey={K.AgGridTable.Keys.BillingClientsVisibleColumn}
          defaultColumnConfig={getColumns(userSlice.roles, editHandler)}
          rowData={billingClientData}
          quickFilterText={search}
        />
      </DataTableLayout>

      <Modal
        open={pageState.isModalVisible}
        okText={pageState.editData ? "Edit" : "Add"}
        wrapClassName="vertical-center-modal"
        centered
        closeIcon={<i className="icon-closeable" />}
        className="s2-theme-style billingClient"
        title={
          pageState.editData
            ? "Edit Configuration"
            : "Clients New Configuration"
        }
        okButtonProps={{ loading: pageState.isLoading }}
        width={462}
        onOk={handleOk}
        onCancel={handleCancel}
        afterClose={afterModalClose}
        destroyOnClose
      >
        <AddNewClientBillingJob
          form={form}
          pageState={pageState}
          setPageState={setPageState}
        />
      </Modal>
    </>
  );
}
